
/*********** Product Images Js *****************/

$(document).ready(function () {
    $('.product__media-list').each(function () {
        $(this).find('li').each(function (index) {
            // Adjust index to 1-based (index + 1) and set --ratio-native to 125.0% on the specified positions
            if ((index + 1) === 1 || (index + 1) === 6 || (index + 1) === 7 || (index + 1) === 11) {
                $(this).css('--ratio-native', '125.0%');
            } else {
                $(this).css('--ratio-native', '100.0%');
            }
        });
    });
});


ratingSnippet("ruk_rating_snippet", {
  store: "honeyglowny.com",
  mode: "default",
  color: "#000000",
  linebreak: false,
  text: "Reviews",
  singularText: "Review",
  lang: "en",
  usePolaris: true,
  showEmptyStars: true,
});